import { Card, Flex, Text, TextInput, Title } from '@tremor/react'
import type { InputsState } from '../types'

interface Props {
    inputs: InputsState
    setInputs: (updates: Partial<InputsState>) => void
}

export default function ContactStep({ inputs, setInputs }: Props) {
    const email = inputs.email || ''
    const isInvalid =
        email.trim().length > 0 && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

    return (
        <Card className="bg-teal-800 ring-teal-900">
            <Title className="text-white">Contact</Title>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="mt-4 flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Email address
                </Text>
                <TextInput
                    placeholder="you@example.com"
                    value={email}
                    onValueChange={(v) => setInputs({ email: v })}
                    error={isInvalid}
                    className="w-full md:w-72"
                />
            </Flex>
            <Text className="text-xs md:text-sm text-white mt-2">
                We use this to send follow-ups or export results if you ask us
                later.
            </Text>
        </Card>
    )
}
